<div class="col-12 px-0 mt-2 d-flex align-items-center wrapper">
    <span class="font-weight-bold mobile-text">{{title}}: </span>
    <span *ngIf="loaded" class="pl-2 mobile-text">{{value}}</span>
    <!-- LOADING -->
    <div *ngIf="!loaded" class="mobile-load">
        <div class="loading loading-text-field mobile-load-width ml-md-2"></div>
    </div>
</div>